import { PageContent } from "../content";
import { useRevealOnScroll } from "../hooks/useRevealOnScroll";
import { FocusAreaItem } from "./FocusAreaItem";

export function FocusAreas({ copy }: { copy: PageContent }) {
  const ref = useRevealOnScroll<HTMLDivElement>();

  return (
    <section id="focus" className="focus" aria-labelledby="focus-title">
      <div ref={ref} className="focus-copy reveal">
        <p className="section-label">{copy.focusLabel}</p>
        <h2 id="focus-title">{copy.focusTitle}</h2>
        <span className="accent-line" aria-hidden="true" />
      </div>
      <div className="focus-grid">
        {copy.focusAreas.map((area, index) => (
          <FocusAreaItem area={area} index={index} key={area.title} />
        ))}
      </div>
    </section>
  );
}
